var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.openPopup } },
        [
          _c(
            "v-card",
            { attrs: { color: "#fff", width: "290" } },
            [
              _c("v-card-text", { staticClass: "card-text-styling" }, [
                _vm._v("\n        " + _vm._s(_vm.message) + "\n      ")
              ]),
              _vm._v(" "),
              _vm.subtitle
                ? _c("v-card-text", { staticClass: "card-sub-text-styling" }, [
                    _vm._v("\n        " + _vm._s(_vm.subtitle) + "\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("v-divider", {
                staticStyle: {
                  "background-color": "rgba(33, 33, 33, 0.08)",
                  "margin-bottom": "30px"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action-btn-styling" },
                [
                  _vm.leftBtnLabel
                    ? _c("Button", {
                        staticClass: "btn-styling",
                        attrs: {
                          label: _vm.leftBtnLabel,
                          outlined: true,
                          buttonColor: "#fff",
                          fontColor: "#000"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("leftBtnClick")
                          }
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.rightBtnLabel
                    ? _c("Button", {
                        staticClass: "btn-styling",
                        attrs: {
                          label: _vm.rightBtnLabel,
                          outlined: false,
                          buttonColor: "#128279",
                          fontColor: "#fff"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("rightBtnClick")
                          }
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }